"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchService = exports.FilterState = void 0;
var tslib_1 = require("tslib");
var core_api_1 = require("@ikegps/core-api");
var core_shared_1 = require("@ikegps/core-shared");
var lodash_1 = require("lodash");
var mobx_1 = require("mobx");
var notification_service_1 = require("../components/notification.toast/notification.service");
var i18n_1 = require("../i18n");
var tag_sort_state_1 = require("../state/tag.sort.state");
var store_1 = require("../store");
var index_1 = require("./index");
var FilterState = /** @class */ (function () {
    function FilterState() {
        this.tagFilters = mobx_1.observable.array([], { deep: false });
    }
    FilterState.prototype.addTagFilter = function (tagFilter) {
        var existing = this.tagFilters.find(function (tag) { return tag.objectId === tagFilter.objectId; });
        if (existing == null) {
            this.tagFilters.push(tagFilter);
        }
        this.filter = null;
    };
    FilterState.prototype.setFilter = function (value) {
        this.filter = value;
    };
    FilterState.prototype.hasFilter = function () {
        return this.tagFilters.length > 0 || (this.filter != null && this.filter.trim().length > 0);
    };
    FilterState.prototype.matches = function (tag) {
        if (tag == null) {
            return false;
        }
        if (!this.hasFilter()) {
            return true;
        }
        if (this.tagFilters.length > 0) {
            return this.tagFilters.find(function (t) { return t.objectId === tag.objectId; }) != null;
        }
        return tag.name.toLowerCase().includes(this.filter.trim().toLowerCase());
    };
    FilterState.prototype.clear = function () {
        this.filter = null;
        this.tagFilters.clear();
    };
    tslib_1.__decorate([
        mobx_1.observable
    ], FilterState.prototype, "filter", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], FilterState.prototype, "addTagFilter", null);
    tslib_1.__decorate([
        mobx_1.action
    ], FilterState.prototype, "setFilter", null);
    tslib_1.__decorate([
        mobx_1.action
    ], FilterState.prototype, "clear", null);
    return FilterState;
}());
exports.FilterState = FilterState;
var dynamicDebounce = function (debouncedAction, getDebounceMs) {
    var cancelableTimeout;
    return function () {
        if (cancelableTimeout) {
            clearTimeout(cancelableTimeout);
        }
        cancelableTimeout = setTimeout(function () {
            debouncedAction();
        }, getDebounceMs());
    };
};
var MAXIMUM_DELAY_MS = 2000;
var MINIMUM_DELAY_MS = 500;
var SearchService = /** @class */ (function () {
    function SearchService() {
        this.__priority = 100;
        this.inFlight = false;
        this.collectionRevisions = mobx_1.observable.array([], { deep: false });
        this.inputfilterState = new FilterState();
        this.filterState = new FilterState();
    }
    SearchService.prototype.getDebounceDelay = function () {
        var charLength = (0, lodash_1.get)(this.inputfilterState, ['filter', 'length']);
        var evaluatedDebounce = charLength ? MAXIMUM_DELAY_MS - ((charLength - 1) * 200) : MINIMUM_DELAY_MS;
        return (0, lodash_1.clamp)(evaluatedDebounce, MINIMUM_DELAY_MS, MAXIMUM_DELAY_MS);
    };
    SearchService.prototype.init = function () {
        var _this = this;
        var search = dynamicDebounce(this.search.bind(this), this.getDebounceDelay.bind(this));
        (0, mobx_1.reaction)(function (_) { return _this.inputfilterState.filter; }, function () {
            if ((0, lodash_1.get)(_this.inputfilterState, ['filter', 'length']) >= core_shared_1.IkeConfigStore.MAX_SEARCH_LENGTH) {
                _this.setInFlight(false);
                notification_service_1.NotificationService.warn({ key: i18n_1.T.SEARCH_ERROR });
            }
            else {
                _this.setInFlight(true);
                search();
            }
        });
        (0, mobx_1.reaction)(function (_) { return index_1.Services.Department.current; }, function (_) { return _this.reset(); });
    };
    SearchService.prototype.reset = function () {
        this.inputfilterState.clear();
        this.filterState.clear();
    };
    SearchService.prototype.includesTag = function (tag) {
        if (this.filterState.hasFilter()) {
            return this.tags.indexOf(tag) > -1;
        }
        return true;
    };
    Object.defineProperty(SearchService.prototype, "tags", {
        get: function () {
            var _this = this;
            if (this.filterState.hasFilter()) {
                return store_1.AppStore.Tag.all.filter(function (tag) { return _this.filterState.matches(tag) || _this.collectionSummaries[tag.objectId] != null; });
            }
            return store_1.AppStore.Tag.all;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SearchService.prototype, "collectionSummaries", {
        get: function () {
            var map = {};
            for (var _i = 0, _a = this.collectionRevisions; _i < _a.length; _i++) {
                var collectionRevision = _a[_i];
                var collectionSummary = store_1.AppStore.CollectionSummary.get(collectionRevision);
                if (collectionSummary == null) {
                    continue;
                }
                if (collectionSummary.tags.indexOf(core_api_1.SystemTag.deleted) > -1) {
                    continue;
                }
                for (var _b = 0, _c = collectionSummary.tags; _b < _c.length; _b++) {
                    var tag = _c[_b];
                    var mapTag = map[tag];
                    if (mapTag == null) {
                        map[tag] = [collectionSummary];
                    }
                    else {
                        mapTag.push(collectionSummary);
                    }
                }
            }
            for (var _d = 0, _e = Object.keys(map); _d < _e.length; _d++) {
                var tagId = _e[_d];
                var summaries = map[tagId];
                tag_sort_state_1.TagSortState.sortSummaries(summaries);
            }
            return map;
        },
        enumerable: false,
        configurable: true
    });
    SearchService.prototype.setInFlight = function (inFlight) {
        this.inFlight = inFlight;
    };
    SearchService.prototype.search = function () {
        var _this = this;
        if (!this.inputfilterState.hasFilter()) {
            this.collectionRevisions.clear();
            this.filterState.setFilter(this.inputfilterState.filter);
            this.setInFlight(false);
            return Promise.resolve();
        }
        this.setInFlight(true);
        var filter = this.inputfilterState.filter;
        return store_1.AppStore.Collection.search(filter)
            .then(function (results) {
            // Old query
            if (filter !== _this.inputfilterState.filter) {
                return null;
            }
            var revisions = results.map(function (result) { return result.revision; });
            return Promise.all(revisions.map(function (revision) { return _this.prefetchCollectionSummary(revision); }))
                .then(function () { return _this.setCollectionRevisions(filter, revisions); });
        });
    };
    SearchService.prototype.setCollectionRevisions = function (filter, collectionRevisions) {
        this.collectionRevisions.replace(collectionRevisions);
        this.filterState.setFilter(filter);
        this.setInFlight(false);
    };
    SearchService.prototype.prefetchCollectionSummary = function (revision) {
        var collectionSummary = store_1.AppStore.CollectionSummary.get(revision);
        if (collectionSummary != null) {
            return collectionSummary;
        }
        return store_1.AppStore.CollectionSummary.fetch(revision);
    };
    tslib_1.__decorate([
        mobx_1.observable
    ], SearchService.prototype, "inFlight", void 0);
    tslib_1.__decorate([
        mobx_1.observable
    ], SearchService.prototype, "collectionRevisions", void 0);
    tslib_1.__decorate([
        mobx_1.computed
    ], SearchService.prototype, "tags", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], SearchService.prototype, "collectionSummaries", null);
    tslib_1.__decorate([
        mobx_1.action
    ], SearchService.prototype, "setInFlight", null);
    tslib_1.__decorate([
        mobx_1.action
    ], SearchService.prototype, "search", null);
    tslib_1.__decorate([
        mobx_1.action
    ], SearchService.prototype, "setCollectionRevisions", null);
    return SearchService;
}());
exports.SearchService = SearchService;
//# sourceMappingURL=search.service.js.map